import React, { useEffect } from 'react';
import queryString from 'query-string';
import LoginForm from './LoginForm';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';

const Login = ({ translate, location }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'conexiontic-oauth-body';
    document.title = 'Conexión TIC';
  }, []);

  return (
    <div className="conexiontic-oauth">
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location} />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')} />}
    </div>
  );
}

export default Login;
